// import Link, { LinkProps } from 'next/link';
import React from 'react';
import { Link, LinkProps } from 'react-router-dom';

export type CustomLinkProps = Omit<
	React.AnchorHTMLAttributes<HTMLAnchorElement>,
	keyof LinkProps | 'href'
> &
	Omit<LinkProps, 'to'> & { href: string };

const CustomLink = ({
	href,
	reloadDocument,
	replace,
	state,
	preventScrollReset,
	relative,
	children,
	...props
}: CustomLinkProps) => {
	const isExternal = `${href}`.startsWith('http') || `${href}`.startsWith('www');

	const linkProps = {
		reloadDocument,
		replace,
		state,
		preventScrollReset,
		relative,
	};

	if (isExternal) {
		return (
			<a href={`${href}`} target="_blank" rel="noopener noreferrer" {...props}>
				{children}
			</a>
		);
	}

	return (
		<Link to={href} {...props} {...linkProps}>
			{children}
		</Link>
	);
};

export default CustomLink;
